import { useState, FormEvent } from 'react'
import { TextInput, PasswordInput, Button, Box, Text, Alert, Stack } from '@mantine/core'
import { IconAlertCircle, IconShieldLock } from '@tabler/icons-react'
import { useNavigate } from 'react-router-dom'
import { usePlatformAuth } from '../../hooks/usePlatformAuth'

export default function PlatformLoginPage() {
  const { doLogin, mustChangePassword } = usePlatformAuth()
  const navigate = useNavigate()
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault()
    setError(null)
    setLoading(true)
    try {
      await doLogin(username, password)
      // ── ใช้ localStorage อ่านตรงๆ ตรงนี้แทนการพึ่ง context ที่เพิ่ง set เสร็จ (state update
      // ยัง async อยู่ตอนนี้ อ่านจาก localStorage ชัวร์กว่าว่าค่าที่เพิ่ง login มาคืออะไรจริงๆ) ──
      const mcp = localStorage.getItem('platform_mustChangePassword') === 'true'
      navigate(mcp ? '/platform/change-password' : '/platform/dashboard', { replace: true })
    } catch (err: any) {
      setError(err?.response?.data?.message ?? 'Invalid username or password')
    } finally {
      setLoading(false)
    }
  }

  return (
    <Box
      style={{
        minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
        background: 'radial-gradient(circle at 30% 20%, #1a2138 0%, #0a0e17 55%)',
        fontFamily: 'Inter, sans-serif',
      }}
    >
      <Box style={{ width: 380 }}>
        <Stack align="center" gap={4} mb={32}>
          <Box style={{
            width: 48, height: 48, borderRadius: 12, background: 'linear-gradient(135deg, #f5a623, #d98c1a)',
            display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 12,
          }}>
            <IconShieldLock size={26} color="#0a0e17" />
          </Box>
          <Text style={{ color: '#fff', fontSize: 20, fontWeight: 700, letterSpacing: '-0.3px' }}>
            AssetOS Platform Console
          </Text>
          <Text style={{ color: '#6b7690', fontSize: 13 }}>
            Restricted access — platform operators only
          </Text>
        </Stack>

        <Box
          component="form"
          onSubmit={handleSubmit}
          style={{
            background: '#131a2c', border: '1px solid #232c44', borderRadius: 14,
            padding: '28px 26px',
          }}
        >
          <Stack gap={16}>
            {error && (
              <Alert icon={<IconAlertCircle size={16} />} color="red" variant="light" radius="md">
                {error}
              </Alert>
            )}
            <TextInput
              label="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              autoFocus
              styles={{
                label: { color: '#9aa3ba', fontSize: 12, fontWeight: 600, marginBottom: 4 },
                input: { background: '#0e1420', border: '1px solid #232c44', color: '#fff' },
              }}
            />
            <PasswordInput
              label="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              styles={{
                label: { color: '#9aa3ba', fontSize: 12, fontWeight: 600, marginBottom: 4 },
                input: { background: '#0e1420', border: '1px solid #232c44', color: '#fff' },
              }}
            />
            <Button
              type="submit"
              loading={loading}
              fullWidth
              size="md"
              mt={4}
              styles={{
                root: {
                  background: 'linear-gradient(135deg, #f5a623, #d98c1a)',
                  color: '#0a0e17', fontWeight: 700,
                  '&:hover': { background: 'linear-gradient(135deg, #ffb43a, #e6971d)' },
                },
              }}
            >
              Sign in
            </Button>
          </Stack>
        </Box>

        <Text ta="center" mt={20} style={{ color: '#4b5468', fontSize: 12 }}>
          Every session on this console is logged.
        </Text>
      </Box>
    </Box>
  )
}
